var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { ref: "emailform", attrs: { id: "sendNoticeForm" } }, [
    _c("p", { staticClass: "bold" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$translate("Snaply5::Template.singleNotificationText")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input-unit" }, [
      _c("input", {
        ref: "email",
        attrs: {
          type: "email",
          name: "email",
          "data-autofocus": "",
          id: "emailForNote",
          required: ""
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "emailForNote" } }, [
        _vm._v(
          _vm._s(_vm.$translate("Snaply5::Template.footerNewsletterEmail")) +
            "*"
        )
      ])
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-primary btn-small btn-block send-notification",
        attrs: { type: "submit" },
        on: {
          click: function($event) {
            return _vm.addToEmailReminderList($event)
          }
        }
      },
      [
        _c("i", { staticClass: "fa fa-envelope" }),
        _vm._v(
          " " +
            _vm._s(
              _vm.$translate("Snaply5::Template.singleNotificationButton")
            ) +
            "\n    "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }